'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var UNDO_STACK_LIMIT = exports.UNDO_STACK_LIMIT = 500;
var UNDO_STACK_SLICE_SIZE = exports.UNDO_STACK_SLICE_SIZE = 400;

var START_OPERATION = exports.START_OPERATION = 'START_OPERATION';
var END_OPERATION = exports.END_OPERATION = 'END_OPERATION';


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/undoRedo/undoRedoConstants.js
// module id = 473
// module chunks = 0